// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  pairKey: __t.string().name("pair_key"),
  granularity: __t.string(),
  timestamp: __t.u64(),
  open: __t.u128(),
  high: __t.u128(),
  low: __t.u128(),
  close: __t.u128(),
  volume: __t.u64(),
  tradeCount: __t.u32().name("trade_count"),
});
